import {
  Box,
  Button,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { SelectField } from "@roc/ui";
import { observer } from "mobx-react";
import { useStore } from "@roc/client-portal-shared/hooks";
import { compsRecencyOptions } from "../../types/filtersOptions";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    width: "400px"
  },
  applyButton: {
    width: "300px"
  }
}));

interface RecencyFiltersProps {
  onApply: () => void;
}

export const RecencyFilters = observer(({ onApply }: RecencyFiltersProps) => {
  const { compToolStoreV2: compToolStore } = useStore();

  const { compToolFiltersStore } = compToolStore;
  const classes = useStyles();

  return (
    <Box display="flex" flexDirection="column" gridGap="1rem" className={classes.root}>
      <Typography variant='body1' style={{ fontWeight: "bold" }}>
        Comparable Property Recency in the last
      </Typography>
      <SelectField
        options={compsRecencyOptions}
        testId={'compRecency'}
        value={compToolFiltersStore.form.fields.MONTHS.values.value}
        onChange={value => compToolFiltersStore.onFieldsChange('MONTHS', 'values', value)}
        fullWidth
        variant="outlined"
        placeholder='Select an option'
      />
      <Box display="flex" justifyContent="center">
        <Button color="primary" variant="outlined" className={classes.applyButton} onClick={() => onApply && onApply()}>Apply</Button>
      </Box>
    </Box>
  );
});
